import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, factory, useProps } from "@components/mantine";
import { useSourceIdentityContext } from "../SourceIdentityContext.js";
import { SOURCE_TYPE_ICON_MAPPINGS } from "../../../images/SourceTypeIconMappings.js";
var defaultProps = {
    size: "lg"
};
export var SourceIdentityTypeImage = factory(function(props, ref) {
    var _ref = useProps("SourceIdentityTypeImage", defaultProps, props), size = _ref.size, others = _object_without_properties(_ref, [
        "size"
    ]);
    var _$ref = useSourceIdentityContext(), getStyles = _$ref.getStyles, sourceType = _$ref.sourceType;
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
        ref: ref,
        "data-size": size
    }, getStyles("typeImage"), others), {
        children: SOURCE_TYPE_ICON_MAPPINGS[sourceType]
    }));
});
SourceIdentityTypeImage.displayName = "@resourceIdentity/source/SourceIdentity/TypeImage";

//# sourceMappingURL=SourceIdentityTypeImage.js.map